import React from 'react';
import './LoadingState.scss';

const LoadingState = () => (
  <div className="loading-root">
    <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
  </div>
);

export default LoadingState;